import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { NumberParam, StringParam, useQueryParams } from "use-query-params";
import { LinkButtonMediumV2 } from "../../../../../../components/Buttons/Buttons";
import { CaretLeft } from "../../../../../../components/Icons/Icons";
import { useRoutePath } from "../../../../../../util/Routing";
import { AddAssetFiles } from "./AddAssetFiles";
import { UploadedAssetsList } from "./UploadedAssetsList";
import { spacingTokens } from "../../../../../../designTokens";

export const UploadAssetsTab = () => {
  const [stage, setStage] = useState<"list" | "add_files">("list");
  const [query, setQuery] = useQueryParams({
    uploadUUID: StringParam,
    uploadNumber: StringParam,
    count: NumberParam,
  });
  const [uploadNumber, setUploadNumber] = useState<string | undefined>();
  const { t } = useTranslation();
  const { adminPath } = useRoutePath();
  const history = useHistory();

  const onCompleteUpload = () => {
    setStage("list");
    setQuery({
      uploadNumber: undefined,
      uploadUUID: undefined,
      count: undefined,
    });
    setUploadNumber(undefined);
  };

  const goBack = () => {
    history.push(`${adminPath}/pim/assets`);
  };

  useEffect(() => {
    if (query.uploadNumber && !uploadNumber) {
      setUploadNumber(query.uploadNumber);
      setStage("add_files");
    }
  }, [query.uploadNumber, uploadNumber]);

  return stage === "list" ? (
    <div style={{ marginTop: spacingTokens.spacing_xl }}>
      <LinkButtonMediumV2 onClick={goBack}>
        <span style={{ marginRight: 4, display: "flex", alignItems: "center" }}>
          <CaretLeft />
        </span>
        {t("Back")}
      </LinkButtonMediumV2>
      <UploadedAssetsList setStage={setStage} removeExternalAssetUploads />
    </div>
  ) : (
    <AddAssetFiles onCompleteUpload={onCompleteUpload} />
  );
};
